import { database, messagesRef, tetrisGameScoreRef, whackamoleGameScoreRef, snakeGameScoreRef, d2048GameScoreRef, profileRef, withPrefix } from '../config/firebase';
import { FETCH_MESSAGES, FETCH_TETRISGAMESCORES, FETCH_WHACKAMOLEGAMESCORES, FETCH_SNAKEGAMESCORES, FETCH_2048GAMESCORES } from './types';
import { ref, push, set, remove, onValue } from 'firebase/database';

// add
export const addMessage = newMessage => async dispatch => {
  const newMessagesRef = push(messagesRef);
  set(newMessagesRef, newMessage);
};

export const addTetrisGameScore = newTetrisGameScore => async dispatch => {
  const newTetrisGameScoreRef = push(tetrisGameScoreRef);
  set(newTetrisGameScoreRef, newTetrisGameScore);
};

export const addWhackamoleGameScore = newWhackamoleGameScore => async dispatch => {
  const newWhackamoleGameScoreRef = push(whackamoleGameScoreRef);
  set(newWhackamoleGameScoreRef, newWhackamoleGameScore);
};

export const addSnakeGameScore = newSnakeGameScore => async dispatch => {
  const newSnakeGameScoreRef = push(snakeGameScoreRef);
  set(newSnakeGameScoreRef, newSnakeGameScore);
};

export const add2048GameScore = new2048GameScore => async dispatch => {
  const newD2048GameScoreRef = push(d2048GameScoreRef);
  set(newD2048GameScoreRef, new2048GameScore);
};

// delete
export const completeMessage = completeMessageId => async dispatch => {
  // Returned so callers (the "Checked" button in ListItem's popup) can
  // await this and only show a success toast / close the popup once the
  // removal has actually gone through, instead of firing optimistically.
  return remove(ref(database, withPrefix('messages') + '/' + completeMessageId));
};

// fetch
export const fetchMessages = () => async dispatch => {
  onValue(messagesRef, (snapshot) => {
    dispatch({
      type: FETCH_MESSAGES,
      payload: snapshot.val()
    });
  });
};


export const fetchTetrisGamesScores = () => async dispatch => {
  onValue(tetrisGameScoreRef, (snapshot) => {
    dispatch({
      type: FETCH_TETRISGAMESCORES,
      payload: snapshot.val()
    });
  });
};

export const fetchWhackamoleGamesScores = () => async dispatch => {
  onValue(whackamoleGameScoreRef, (snapshot) => {
    dispatch({
      type: FETCH_WHACKAMOLEGAMESCORES,
      payload: snapshot.val()
    });
  });
};

export const fetchSnakeGamesScores = () => async dispatch => {
  onValue(snakeGameScoreRef, (snapshot) => {
    dispatch({
      type: FETCH_SNAKEGAMESCORES,
      payload: snapshot.val()
    });
  });
};

export const fetch2048GamesScores = () => async dispatch => {
  onValue(d2048GameScoreRef, (snapshot) => {
    dispatch({
      type: FETCH_2048GAMESCORES,
      payload: snapshot.val()
    });
  });
};

//update
export const updateProfile = profile => async dispatch => {
  await set(profileRef, profile);
};